import { z } from 'zod';
import { Currency, ItemType, SourceSystem } from '../enums.js';
import { IsoDateTime, UuidString } from '../primitives.js';

/** ItemGroup (tree через parent_id). */
export const ItemGroup = z.object({
  id: UuidString,
  entity_id: UuidString,
  name: z.string().min(1),
  parent_id: UuidString.nullable(),
  path: z.array(z.string()).default([]),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type ItemGroup = z.infer<typeof ItemGroup>;

/** Item master. */
// S-FIX-4: BE list handler omits internal fields; made optional to accept
// real prod data shape. Detail endpoint still returns full entity.
export const Item = z.object({
  id: UuidString,
  entity_id: UuidString.optional(),
  sku: z.string().min(1),
  name: z.string().min(1),
  item_type: ItemType.optional(),
  item_group_id: UuidString.nullable().optional(),
  default_uom: z.string().optional(),
  stock_uom: z.string().optional(),
  has_variants: z.boolean().default(false),
  has_batch_no: z.boolean().default(false),
  has_serial_no: z.boolean().default(false),
  is_stock_item: z.boolean().default(true),
  is_purchase_item: z.boolean().default(true),
  is_sales_item: z.boolean().default(true),
  price_currency: Currency.nullable().optional(),
  description: z.string().nullable().optional(),
  hs_code: z.string().nullable().optional().default(null),
  specs: z.record(z.string()).nullable().optional().default(null),
  source_system: SourceSystem.optional(),
  source_document_id: z.string().nullable().optional(),
  source_system_ref: z.record(z.unknown()).nullable().optional(),
  fetched_at: IsoDateTime.nullable().optional(),
  created_at: IsoDateTime.optional(),
  updated_at: IsoDateTime.optional(),
});
export type Item = z.infer<typeof Item>;

/** ItemVariant — template + attribute-value combination.
 *  UI-форма bulk-create может содержать только часть полей (без id/entity_id/timestamps). */
export const ItemVariant = z.object({
  id: UuidString.optional(),
  entity_id: UuidString.optional(),
  parent_item_id: UuidString.optional(),
  variant_sku: z.string().min(1).optional(),
  /** UI-alias для variant_sku в bulk-upsert payload. */
  sku: z.string().min(1).optional(),
  attributes: z.record(z.string()),
  is_active: z.boolean().optional(),
  created_at: IsoDateTime.optional(),
  updated_at: IsoDateTime.optional(),
});
export type ItemVariant = z.infer<typeof ItemVariant>;
